import React, { FC, memo, useMemo } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import theme from '@src/theme/theme';

interface Props {
  className?: string;
  classNameWrap?: string;
  count?: number;
}

const SkeletonLoader: FC<Props> = ({
  className = '',
  classNameWrap,
  count = undefined,
}) => {
  const loaderCount = useMemo(
    () => Array.from({ length: count ?? 0 }, (_, index) => index + 1),
    [count],
  );

  const colors = useMemo(
    () => ({
      baseColor: theme.palette.custom.elements.skeletonPrimary,
      highlightColor: theme.palette.custom.elements.skeletonSecondary,
    }),
    [],
  );

  return (
    <>
      {count ? (
        <SkeletonTheme
          baseColor={colors.baseColor}
          highlightColor={colors.highlightColor}
          inline
        >
          {loaderCount.map((item) => (
            <div
              key={String(item)}
              style={{ width: '100%' }}
              className={classNameWrap}
            >
              <Skeleton className={className} key={String(item)} inline />
            </div>
          ))}
        </SkeletonTheme>
      ) : (
        <SkeletonTheme
          baseColor={colors.baseColor}
          highlightColor={colors.highlightColor}
          inline
        >
          <div style={{ width: '100%' }} className={classNameWrap}>
            <Skeleton className={className} inline />
          </div>
        </SkeletonTheme>
      )}
    </>
  );
};

export default memo(SkeletonLoader);
